module.exports = __webpack_public_path__ + "img/title.41ce8aec.png";